<script>
import _debounce from "lodash/debounce";
import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch','errorValid'],
  data() {
    return {
      header: this.$constant.tableHeaders.work_reservation.vendor_sites,
      isLoading: false,
      data: [],
      showModal: false,
      filters: {
        searchValue: '',
        column: "vendor_site_cd",
        dir: "ASC",
      }
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = this.caseId ? apiEndpoints.popup_search_vendor_sites_by_case_id(this.caseId) : apiEndpoints.popup_search_vendor_sites_all;
      const {status, data} = await this.$http.get(url, this.filters)
      this.isLoading = false;
      if (status) {
        const result = data.result;
        this.data = this.$_.isEmpty(result) ? [] : result;
      }
    },
    updateValue: function (value) {
      this.dataSearch.vendor_site_name_abbreviated = value;
      this.$emit('dataSelected', this.dataSearch)
      this.closeModal();
    },
    openModal() {
      this.getData()
      this.showModal = true
    },
    closeModal() {
      this.showModal = false;
    },
    performDebounceSearch() {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters() {
      this.getData()
    },
    isInputError(input){
      if (!this.errorValid) return false;

      return !!this.errorValid[input];
    },
  },
  computed: {
    caseId() {
      return this.$route.params.case_id
    },
    inputSearch: {
      get() {
        return this.dataSearch.vendor_site_name_abbreviated;
      },
      set(newValue) {
        this.dataSearch.vendor_site_name_abbreviated = newValue;
      }
    }
  },
};
</script>
<template>
  <b-row>
    <b-col align-self="center" cols="2">運搬先</b-col>
    <b-col class="d-flex">
      <div class="w-100 me-2">
        <input
          type="text"
          class="form-control me-2"
          v-model="inputSearch"
          maxlength="20"
          :class="{
              'is-invalid': isInputError('vendor_site_name_abbreviated')
            }"
        />
        <div
          v-if="isInputError('vendor_site_name_abbreviated')"
          class="invalid-feedback"
        >
          {{ errorValid['vendor_site_name_abbreviated'][0] }}
        </div>
      </div>
      <b-button
        @click="openModal()"
        variant="outline-info"
        class="cus-h-btn"
      >
        <i class="bx bx-file-find"/>
      </b-button>
    </b-col>
    <Transition name="fade">
      <div v-if="showModal" class="position-absolute z-index" style="z-index: 1041;">
        <div class="modal d-block" aria-modal="true" @click.self="showModal = false">
          <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <header class="modal-header">
                <h5 class="modal-title font-18">運搬先一覧</h5>
                <button type="button" aria-label="Close" class="close" @click="showModal = false">×</button>
              </header>
              <div class="modal-body">
                <b-row>
                  <div>
                    <b-form-input
                      placeholder="フィルター..."
                      v-model="filters.searchValue"
                      v-on:keyup.enter="performDebounceSearch"
                      type="text"
                    ></b-form-input>
                  </div>
                </b-row>
                <b-row class="mt-2">
                  <b-overlay
                    :show="isLoading"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block"
                  >
                    <CommonTableComponent :height-class="`table-wrapper-500`">
                      <thead class="table-light">
                      <tr>
                        <th
                          v-for="item in header"
                          :class="getHeaderClass(item)"
                        >
                  <span v-if="item.sortable" @click="clickSort(item.value)">
                    {{ item.text }}
                    <i :class="getSortClass(item.value)"></i>
                  </span>
                          <span v-else>
                    {{ item.text }}
                  </span>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                        v-for="item in data"
                        class="cursor-pointer"
                        @click="updateValue(item.name_abbreviated)"
                      >
                        <td>
                          {{ item.vendor_site_cd }}
                        </td>
                        <td>
                          {{ item.name_abbreviated }}
                        </td>
                        <td>
                          {{ item.address }}
                        </td>
                        <td>
                          {{ item.tel }}
                        </td>
                        <td>
                          {{ item.vendor_site_person_in_charge }}
                        </td>
                        <td>
                          {{ item.user_name_1 }}
                        </td>
                        <td>
                          {{ item.user_name_2 }}
                        </td>
                        <td>
                          {{ item.own }}
                        </td>
                      </tr>
                      <tr v-if="!data.length && !isLoading">
                        <td :colspan="header.length" class="text-center">
                          データなし。
                        </td>
                      </tr>
                      </tbody>
                    </CommonTableComponent>
                  </b-overlay>
                </b-row>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </Transition>
  </b-row>
</template>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.cus-h-btn {
  max-height: 38px;
}
</style>
